// extracted by mini-css-extract-plugin
export default {"template":"DeepPageTemplate_template__V3n2z"};